module.exports = __webpack_public_path__ + "img/sleep-banner.b76195e4.png";